import { render, staticRenderFns } from "./SubcontractDetail.vue?vue&type=template&id=04085921&"
import script from "./SubcontractDetail.vue?vue&type=script&lang=js&"
export * from "./SubcontractDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports